import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraAvatar } from '@mono/ui-components';
import { TIMEZONE_OPTIONS } from '../constants';
function KeyValueRow({ label, value }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-between gap-4 px-4 py-3",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-sm text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "min-w-0 truncate text-sm font-medium text-foreground",
                children: value || '—'
            })
        ]
    });
}
export function ProfileSettings({ company, email, name, onTimezoneChange, role, timezone }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ _jsxs("section", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-base font-medium text-foreground",
                        children: "Account"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraAvatar, {
                                name: name || email,
                                size: "md"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "truncate text-sm font-medium text-foreground",
                                        children: name || '—'
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "truncate text-sm text-muted-foreground",
                                        children: email
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "divide-y divide-border rounded-lg border border-border",
                        children: [
                            /*#__PURE__*/ _jsx(KeyValueRow, {
                                label: "Role",
                                value: role
                            }),
                            /*#__PURE__*/ _jsx(KeyValueRow, {
                                label: "Company",
                                value: company
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-xs text-muted-foreground",
                        children: "These details are managed by your organization. Contact an admin to change them."
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-base font-medium text-foreground",
                        children: "Preferences"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "max-w-sm",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "mb-1 block text-sm font-medium text-foreground",
                                htmlFor: "profile-timezone",
                                children: "Timezone"
                            }),
                            /*#__PURE__*/ _jsx("select", {
                                className: "w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                                id: "profile-timezone",
                                onChange: (e)=>onTimezoneChange(e.target.value),
                                value: timezone,
                                children: TIMEZONE_OPTIONS.map((option)=>/*#__PURE__*/ _jsx("option", {
                                        value: option.value,
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
